import styled from 'styled-components';

// CONSTANTS
import { GRAY_SUIT, MAIN_BLACK } from '@/constants/colors';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  padding-top: 32px;

  .swiper-container {
    padding: 15px 0;

    ${breakpoints.down('xs')} {
      overflow: visible;
      padding-bottom: 0;
    }
  }

  .swiper-button-nav {
    top: 22px;
    left: auto;

    height: 32px;
    width: 32px;
  }

  .swiper-button-prev {
    right: 32px;
  }

  .swiper-button-next {
    right: 0;
  }

  .swiper-button-disabled {
    opacity: 0.4;
  }

  .swiper-button-lock {
    display: none;
  }

  .swiper-pagination-bullet-active {
    background: ${MAIN_BLACK};
  }

  &.where-to-watch {
    .swiper-container {
      width: calc(100% + 30px);
      margin: -30px -15px 0;
      padding: 40px 15px 30px;
    }

    .swiper-wrapper {
      align-items: stretch;
      height: 100% !important;
    }

    .swiper-pagination-bullets {
      bottom: -9px;

      .swiper-pagination-bullet {
        opacity: 1;
        width: 8px;
        height: 8px;
        margin: 0 4px;
        background: ${GRAY_SUIT};
        border-radius: 50%;
      }
    }

    ${breakpoints.down('xs')} {
      .swiper-button-next,
      .swiper-button-prev {
        &::after {
          content: none;
        }
      }
    }
  }

  &.want-to-watch {
  }

  &.collections {
  }

  &.default {
  }

  &.default,
  &.collections {
    ${breakpoints.up('lg')} {
      padding-top: 0;
      transform: translateX(-35px);
      width: calc(100% + 70px);

      .swiper-container {
        padding: 0;
        width: calc(100% - 70px);
      }

      .swiper-button-prev,
      .swiper-button-next {
        top: 50%;
        transform: translateY(-50%);
        width: 42px;
        height: 42px;

        &::after {
          font-size: 32px;
        }
      }

      .swiper-button-prev {
        left: -10px;
      }

      .swiper-button-next {
        right: -10px;
      }

      .swiper-button-disabled {
        display: none;
      }
    }
  }

  &.watchlists {
    padding-top: 0;
    transform: translateX(-35px);
    width: calc(100% + 70px);

    .swiper-slide {
      height: auto;
    }

    .swiper-container {
      padding: 0;
      width: calc(100% - 70px);
    }

    .swiper-button-prev,
    .swiper-button-next {
      top: 50%;
      transform: translateY(-50%);
      width: 42px;
      height: 42px;

      &::after {
        font-size: 32px;
      }

      ${breakpoints.down('xs')} {
        display: none;
      }
    }

    .swiper-button-prev {
      left: -10px;
    }

    .swiper-button-next {
      right: -10px;
    }

    .swiper-button-disabled {
      display: none;
    }
  }
`;

export default Wrapper;
